import App from './App';
import ReactDOM from 'react-dom';
import 'src/utils/chart';
import * as serviceWorker from './serviceWorker';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { store, persistor } from './store/RootReducer';
import { Provider } from 'react-redux';
import 'react-sortable-tree/style.css';
import 'nprogress/nprogress.css';
import { SidebarProvider } from './contexts/SidebarContext';
import { CollapseProvider } from './contexts/CollapseContext';
import { PersistGate } from 'redux-persist/integration/react';

ReactDOM.render(
  <HelmetProvider>
    <SidebarProvider>
      <CollapseProvider>
        <BrowserRouter>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <App />
            </PersistGate>
          </Provider>
        </BrowserRouter>
      </CollapseProvider>
    </SidebarProvider>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
